<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">
    <!-- Sidenav toggle -->
    <b-navbar-nav class="align-items-lg-center mr-auto mr-lg-4" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 ml-2 ml-lg-0" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <!-- Brand -->
    <b-navbar-brand to="/home" class="app-brand demo py-0 mr-4">
      <!-- <span >
        <img src="/img/header-logo.png" alt class="d-block ui-w-40 rounded-circle">
      </span> -->

      <span class="app-brand-text demo font-weight-bolder ml-2">{{headertitle}}</span>
    </b-navbar-brand>

    <!-- Navbar toggle -->
    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <b-navbar-nav class="align-items-lg-center ml-auto">

        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <!-- <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{username}}</span> -->
              <i class="ion ion-md-settings text-large align-middle" />
            </span>
          </template>
          <!-- <b-dd-item><i class="ion ion-ios-person text-lightest"></i> &nbsp; My profile</b-dd-item> -->
          <b-dd-item v-on:click="acctSettings()"><i class="ion ion-md-settings text-lightest"></i> &nbsp; Account Settings</b-dd-item>
          <b-dd-divider />
          <b-dd-item v-on:click="logout()"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; Log Out</b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
</template>

<script>
import { deleteLocalStorage } from '@/common/helper'
import { ENV_HEADER_TITLE } from '@/common/environment'

export default {
  name: 'app-layout-navbar',
  // computed: mapGetters(['authUsername', 'authUsername']),
  data () {
    return {
      headertitle: 'Zion',
      username: localStorage.getItem('fname') + ' ' + localStorage.getItem('lname')
    }
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.headertitle = ENV_HEADER_TITLE // process.env.VUE_APP_HEADER_TITLE
  },
  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },
    logout () {
      deleteLocalStorage()
      // delete localStorage.token
      this.$router.replace('/login')
    },
    acctSettings () {
      this.$router.replace('/system/accountsettings')
    }
  }
}
</script>
